var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRevisionBlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "test_1_",
    "data-name": "test (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 152.98,
    height: 199.81,
    viewBox: "0 0 152.98 199.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14665",
    "data-name": "Path 14665",
    d: "M135.418,23.805H117.466V17.561a5.854,5.854,0,0,0-5.854-5.854H93.048a17.563,17.563,0,0,0-33.117,0H40.977a5.854,5.854,0,0,0-5.854,5.854v6.244H17.561A17.581,17.581,0,0,0,0,41.367V182.249A17.581,17.581,0,0,0,17.561,199.81H135.418a17.581,17.581,0,0,0,17.561-17.561V41.367A17.581,17.581,0,0,0,135.418,23.805Zm-88.588-.39H64.782a5.854,5.854,0,0,0,5.854-5.854,5.854,5.854,0,1,1,11.708,0A5.854,5.854,0,0,0,88.2,23.415h17.561v6.244a5.86,5.86,0,0,1-5.854,5.854H52.684a5.86,5.86,0,0,1-5.854-5.854Zm94.441,158.833a5.86,5.86,0,0,1-5.854,5.854H17.561a5.86,5.86,0,0,1-5.854-5.854V41.367a5.86,5.86,0,0,1,5.854-5.854H36.13A17.589,17.589,0,0,0,52.684,47.221H99.905A17.589,17.589,0,0,0,116.46,35.513h18.959a5.86,5.86,0,0,1,5.854,5.854Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "padlock_2_",
    "data-name": "padlock (2)",
    d: "M53.959,29.12H51.533V19.413a19.413,19.413,0,1,0-38.826,0V29.12H10.28A7.289,7.289,0,0,0,3,36.4V70.372a7.289,7.289,0,0,0,7.28,7.28H53.959a7.289,7.289,0,0,0,7.28-7.28V36.4A7.289,7.289,0,0,0,53.959,29.12ZM19.178,19.413a12.942,12.942,0,1,1,25.884,0V29.12H19.178ZM35.355,54.1v7.37a3.236,3.236,0,0,1-6.471,0V54.1a6.471,6.471,0,1,1,6.471,0Z",
    transform: "translate(44.37 70.636)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRevisionBlocked);
export default __webpack_public_path__ + "static/media/icon-revision-blocked.7cf193d5.svg";
export { ForwardRef as ReactComponent };